import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (rovers.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "rovers" */ "../views/About.vue"),
  },
  {
    path: "/image-library",
    name: "image library",
    // route level code-splitting
    // this generates a separate chunk (rovers.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "rovers" */ "../views/ImageLibraryView.vue"),
  },
  {
    path: "/rovers",
    name: "rovers",
    // route level code-splitting
    // this generates a separate chunk (rovers.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "rovers" */ "../views/RoversView.vue"),
  },
  {
    path: "/mars-weather",
    name: "mars weather",
    // route level code-splitting
    // this generates a separate chunk (rovers.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "rovers" */ "../views/MarsWeatherView.vue"),
  },
  {
    path: "/asteroid-monitor",
    name: "asteroid monitor",
    // route level code-splitting
    // this generates a separate chunk (rovers.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "rovers" */ "../views/AsteroidMonitorView.vue"
      ),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
